import React, {useEffect, useState} from "react"
import {Layout} from "antd"
import clsx from "clsx"
import {useLocation} from "react-router-dom"

import HeaderComponent from "../Header";
import FooterComponent from "../Footer";
import SideBarComponent from "../SideBar";
import DevicesExplorer, {EXPLORER_PANEL_WIDTH} from "../../pages/Devices/components/DevicesExplorer";
import {usePermissions} from "../../hooks/usePermissions";
import {DEVICES, SENSOR_DASHBOARD, SENSOR_GRAPHS} from "../PrivateRoute/components/constants";

import classes from "./Layout.module.scss"

const {Content} = Layout

// Routes the Devices Explorer panel is available on — Devices grid, Sensor
// Dashboard, and Sensor Graphs, so a user can always see/select the device
// they're currently viewing without leaving the page.
const EXPLORER_ROUTE_PREFIXES = [DEVICES, SENSOR_DASHBOARD[0], SENSOR_GRAPHS];

interface LayoutProps {
    children: any
    isTablet: boolean
}

const LayoutComponent: React.FC<LayoutProps> = ({children, isTablet}) => {
    const [collapsed, setCollapsed] = useState<boolean>(true)
    const {isExplorerEnabled} = usePermissions();
    const {pathname} = useLocation();

    useEffect(() => {
        setCollapsed(isTablet)
    }, [isTablet])


    const toggle = () => {
        setCollapsed(!collapsed)
    }

    const sidebarWidth = (isTablet || collapsed) ? 80 : 200;
    const showExplorer = isExplorerEnabled && EXPLORER_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
    const contentMarginLeft = sidebarWidth + (showExplorer ? EXPLORER_PANEL_WIDTH : 0);

    return (
        <Layout className={classes.wrap}>
            <SideBarComponent collapsed={collapsed}
                              isTablet={isTablet}
                              toggle={toggle}
            />

            {showExplorer && <DevicesExplorer sidebarWidth={sidebarWidth}/>}

            <Layout className="site-layout" style={{marginLeft: contentMarginLeft}}>
                <HeaderComponent/>

                <Content>
                    <div className={clsx("site-layout-background",
                        classes.contentContainer)}>
                        {children}
                    </div>
                </Content>

                <FooterComponent/>
            </Layout>
        </Layout>
    )
}

export default LayoutComponent
